import { useEffect, useState } from 'react'
import { BANNER_HEIGHT_VARIABLE } from '@/shared/theme/bannerHeight'

const useBannerHeight = (enabled: boolean) => {
  const [banner, setBanner] = useState<HTMLElement | null>(null)

  useEffect(() => {
    if (!enabled || !banner) return undefined

    const root = document.documentElement
    const observer = new ResizeObserver(([entry]) => {
      root.style.setProperty(BANNER_HEIGHT_VARIABLE, `${entry.contentRect.height}px`)
    })
    observer.observe(banner)

    return () => {
      observer.disconnect()
      root.style.removeProperty(BANNER_HEIGHT_VARIABLE)
    }
  }, [enabled, banner])

  return setBanner
}

export default useBannerHeight
